import React from "react";
import LandingPageLayout from "../LandingPageLayout";
import LandingPage from "../pages/LandingPage";

const LandingPageRoutes = [
  {
    path: "/",
    element: <LandingPageLayout />,
    children:[
        {
            index: true,
            element: <LandingPage/>
        }
    ]
  },
];

export default LandingPageRoutes;
